export enum EventOfferStatusEnum {
    Rejected,
    Pending,
    Accepted,
    Canceled,
    NewOfferRequested
}
